"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferFieldContactEmail = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const types_1 = require("@src/types");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const email_1 = require("@src/helpers/form-validation-rules/email");
const OfferFieldContactEmail = () => {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
            id: 'admin.offer_form.contact_email',
        }), name: types_1.EOfferBasicInfoFormField.contact_email, rules: [{ ...(0, email_1.getEmailRules)(intl)[1] }], children: (0, jsx_runtime_1.jsx)(elements_1.Input, { maxLength: 250, placeholder: intl.formatMessage({
                id: 'admin.offer_form.contact_email_placeholder',
            }) }) }));
};
exports.OfferFieldContactEmail = OfferFieldContactEmail;
